'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

const DonateHero = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary via-primary/90 to-secondary py-20 overflow-hidden">
      <div className="absolute inset-0 bg-[url('/assets/images/pattern.svg')] opacity-10"></div>
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 rounded-full mb-6 animate-pulse-gentle">
          <Icon name="HeartIcon" size={40} className="text-white" variant="solid" />
        </div>
        
        <h1 className="text-5xl md:text-6xl font-headline font-bold text-white mb-6">
          Make Your Impact Today
        </h1>
        
        <p className="text-xl md:text-2xl text-white/90 font-body max-w-3xl mx-auto mb-8">
          Every contribution transforms lives. Support vulnerable communities through transparent, 
          direct giving with 100% accountability.
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto mt-12">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
            <Icon name="ShieldCheckIcon" size={32} className="text-white mx-auto mb-3" variant="solid" />
            <h3 className="text-lg font-cta font-bold text-white mb-2">100% Transparent</h3>
            <p className="text-sm text-white/80 font-body">Track every dollar from donation to delivery</p>
          </div>
          
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
            <Icon name="GlobeAltIcon" size={32} className="text-white mx-auto mb-3" variant="solid" />
            <h3 className="text-lg font-cta font-bold text-white mb-2">Global Reach</h3>
            <p className="text-sm text-white/80 font-body">Supporting communities across continents</p>
          </div>
          
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
            <Icon name="BoltIcon" size={32} className="text-white mx-auto mb-3" variant="solid" />
            <h3 className="text-lg font-cta font-bold text-white mb-2">Immediate Impact</h3>
            <p className="text-sm text-white/80 font-body">Direct support to those who need it most</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DonateHero;